class CollectionSection extends HTMLElement {
  constructor() {
    super();

    this.pageOverlayClass = "page-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.drawer = () => document.querySelector(".wt-filter");
    this.classDrawerActive = "wt-filter--drawer-open";
    this.triggerQuery = [".wt-filter__close", `.${this.pageOverlayClass}`].join(
      ", ",
    );
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    this.overlay = document.createElement("div");

    this.init();
  }

  init() {
    this.createOverlay();
    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => this.toggleDrawer(e));
      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
          this.toggleDrawer(e);
        }
      });
    });
  }

  toggleDrawer(e) {
    if (e) e.preventDefault();

    //TODO: apply this fix only for mobile
    if (document.body.classList.contains(this.activeOverlayBodyClass)) {
      const offsetTop = -parseInt(document.body.style.top);
      document.body.style.position = "initial";
      document.body.style.top = "initial";
      document.body.style.left = "initial";
      window.scrollTo(0, offsetTop);
    } else {
      document.body.style.top = -document.documentElement.scrollTop + "px";
      document.body.style.left = "0px";
    }

    this.drawer()?.classList.toggle(this.classDrawerActive);
    document.body.classList.toggle(this.activeOverlayBodyClass);
  }

  createOverlay() {
    if (!document.querySelector(`.${this.pageOverlayClass}`)) {
      this.overlay?.classList.add(this.pageOverlayClass);
      document.body.appendChild(this.overlay);
    }
  }
}

customElements.define("collection-section", CollectionSection);
